/* eslint-disable */
// @ts-nocheck

import React, { useState } from 'react'
import { toast } from 'react-toastify'

import {
  PencilIcon as _PencilIcon,
  PlusIcon,
} from '@heroicons/react/24/outline'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  createOriginDestiny,
  updateOriginDestiny,
} from '@/api/originDestinyAPI'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface OriginDestinyManagerProps {
  type: 'origin' | 'destiny'
  onSelect: (_item: { id: number; name: string }) => void
  selectedValue?: { id: number; name: string }
}

export default function OriginDestinyManager({
  type,
  onSelect,
  selectedValue,
}: OriginDestinyManagerProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    countryId: 10, // Default country ID
  })

  const queryClient = useQueryClient()

  const createMutation = useMutation({
    mutationFn: createOriginDestiny,
    onSuccess: (data) => {
      toast.success(
        `${type === 'origin' ? 'Origen' : 'Destino'} creado exitosamente`
      )
      queryClient.invalidateQueries({ queryKey: ['origin_destiny'] })
      onSelect({ id: data.id, name: data.name })
      setIsOpen(false)
      setFormData({ name: '', description: '', countryId: 10 })
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.data?.message ||
          `Error al crear ${type === 'origin' ? 'origen' : 'destino'}`
      )
    },
  })

  const updateMutation = useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) =>
      updateOriginDestiny(id, data),
    onSuccess: (data) => {
      toast.success(
        `${type === 'origin' ? 'Origen' : 'Destino'} actualizado exitosamente`
      )
      queryClient.invalidateQueries({ queryKey: ['origin_destiny'] })
      onSelect({ id: data.id, name: data.name })
      setIsOpen(false)
      setFormData({ name: '', description: '', countryId: 10 })
      setIsEditing(false)
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.data?.message ||
          `Error al actualizar ${type === 'origin' ? 'origen' : 'destino'}`
      )
    },
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    if (isEditing && selectedValue) {
      updateMutation.mutate({
        id: selectedValue.id,
        data: {
          name: formData.name,
          description: formData.description,
        },
      })
    } else {
      createMutation.mutate({
        name: formData.name,
        countryId: formData.countryId,
      })
    }
  }

  const _handleEdit = () => {
    if (selectedValue) {
      setFormData({
        name: selectedValue.name,
        description: '',
        countryId: 10,
      })
      setIsEditing(true)
      setIsOpen(true)
    }
  }

  const handleCreate = () => {
    setFormData({ name: '', description: '', countryId: 10 })
    setIsEditing(false)
    setIsOpen(true)
  }

  return (
    <div className="flex items-center gap-2">
      {/* No mostrar el nombre del origen/destino seleccionado */}

      <Dialog onOpenChange={setIsOpen} open={isOpen}>
        <DialogTrigger asChild>
          <Button
            className="h-10 w-10 p-0"
            onClick={handleCreate}
            type="button"
            variant="outline"
          >
            <PlusIcon className="h-4 w-4" />
          </Button>
        </DialogTrigger>
        {/* No mostrar botón de editar */}

        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {`Crear ${type === 'origin' ? 'Origen' : 'Destino'}`}
            </DialogTitle>
          </DialogHeader>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <Label htmlFor="name">Nombre</Label>
              <Input
                id="name"
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, name: e.target.value }))
                }
                placeholder={`Nombre del ${type === 'origin' ? 'origen' : 'destino'}`}
                required
                value={formData.name}
              />
            </div>
            {/* No mostrar campo de descripción ni edición */}
            <div className="flex justify-end gap-2">
              <Button
                onClick={() => setIsOpen(false)}
                type="button"
                variant="outline"
              >
                Cancelar
              </Button>
              <Button
                disabled={createMutation.isPending || updateMutation.isPending}
                type="submit"
              >
                {createMutation.isPending ? 'Guardando...' : 'Crear'}
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  )
}
